import { G2 } from '@ant-design/plots';

import { colorTheme } from '@components/Data/Charts/utils';

const { registerTheme } = G2;
registerTheme('custom-theme', colorTheme);
